
import { call } from "redux-saga/effects";

import { API_URLS } from "../resources/constants";
import { formQueryString } from '../resources/functions'
import {CallApi} from './callApi'

export function* auth(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.QUICK_BOOK.AUTH + '?' + formQueryString(payload)
    let result = yield call(CallApi.GET, url,{},true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* callback(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.QUICK_BOOK.CALLBACK + '?' + formQueryString(payload)
    let result = yield call(CallApi.GET, url,{},true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* importDate(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.QUICK_BOOK.IMPORT_DATA + '?' + formQueryString(payload)
    let result = yield call(CallApi.POST, url,{},true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* fetchAccountChart(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.QUICK_BOOK.FETCH_ACCOUNT_CHARTS + '?' + formQueryString(payload)
    let result = yield call(CallApi.GET, url,{},true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* classificationMap(action: any): any {
  try {
    const url = API_URLS.QUICK_BOOK.CLASSIFICATION_MAP;
    let result = yield call(CallApi.GET, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* matchQboParent(action: any): any {
  try {
    const url = API_URLS.QUICK_BOOK.PARENT_MATCH + '?' + formQueryString(action.payload);
    let result = yield call(CallApi.GET, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* postAccountChart(action: any): any {
  try {
    const { records, branch_id, dry_run } = action.payload;
    const url = API_URLS.QUICK_BOOK.POST_ACCOUNT_CHARTS + '?branch_id=' + branch_id + (dry_run ? '&dry_run=true' : '');
    let result = yield call(CallApi.POST, url, records, true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbFetchOpenningAcc(action: any): any {
  try {
    const payload = action.payload;
    //console.log(payload);
    const url = API_URLS.QUICK_BOOK.QB_FETCH_OPENNING_BALANCE + `?` +  formQueryString(payload)
    let result = yield call(CallApi.GET, url, {}, true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbPostOpenningAcc(action: any): any {
  try {
    const { formData, queryString } = action.payload;
    const url = API_URLS.QUICK_BOOK.QB_POST_OPENNING_BALANCE + `?` +  formQueryString(queryString)
    let result = yield call(CallApi.POST, url, formData, true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbFetchBSPL(action: any): any {
  try {
    const payload = action.payload;
    //console.log(payload);
    const url = API_URLS.QUICK_BOOK.QB_FETCH_BS_PL + `?` +  formQueryString(payload)
    let result = yield call(CallApi.GET, url, {}, true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbPostBSPL(action: any): any {
  try {
    const { records, branch_id, override_verification } = action.payload;
    //console.log(payload);
    let url = API_URLS.QUICK_BOOK.QB_POST_BS_PL + '?branch_id=' + branch_id;
    if (override_verification) {
      url += '&override_verification=true';
    }
    let result = yield call(CallApi.POST, url, records, true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbFetchBS(action: any): any {
  try {
    const payload = action.payload;
    //console.log(payload);
    const url = API_URLS.QUICK_BOOK.QB_FETCH_BS + `?` +  formQueryString(payload)
    let result = yield call(CallApi.GET, url, {}, true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbFetchPL(action: any): any {
  try {
    const payload = action.payload;
    //console.log(payload);
    const url = API_URLS.QUICK_BOOK.QB_FETCH_PL + `?` +  formQueryString(payload)
    let result = yield call(CallApi.GET, url, {}, true);
    //yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbFetchVendors(action: any): any {
  try {
    const payload = action.payload || {};
    const queryParams = new URLSearchParams();

    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, String(value));
      }
    });

    const queryString = queryParams.toString();
    const url = queryString
      ? `${API_URLS.QUICK_BOOK.QB_FETCH_VENDORS}?${queryString}`
      : API_URLS.QUICK_BOOK.QB_FETCH_VENDORS;
    let result = yield call(CallApi.GET, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbFetchCustomers(action: any): any {
  try {
    const payload = action.payload || {};
    const queryParams = new URLSearchParams();

    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, String(value));
      }
    });

    const queryString = queryParams.toString();
    const url = queryString
      ? `${API_URLS.QUICK_BOOK.QB_FETCH_CUSTOMERS}?${queryString}`
      : API_URLS.QUICK_BOOK.QB_FETCH_CUSTOMERS;
    let result = yield call(CallApi.GET, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbFetchJobStatus(action: any): any {
  try {
    const { job_id } = action.payload;
    const url = API_URLS.QUICK_BOOK.QB_JOB_STATUS + `/${job_id}`
    let result = yield call(CallApi.GET, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbAcknowledgeJobWarnings(action: any): any {
  try {
    const { job_id } = action.payload;
    const url = API_URLS.QUICK_BOOK.QB_ACKNOWLEDGE_JOB_WARNINGS + `/${job_id}`
    let result = yield call(CallApi.POST, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbFetchImportJobStatus(action: any): any {
  try {
    const { job_id, branch_id } = action.payload;
    const url = API_URLS.QUICK_BOOK.QB_IMPORT_JOB_STATUS + `/${job_id}?branch_id=${branch_id}`
    let result = yield call(CallApi.GET, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbFetchBackupLatest(action: any): any {
  try {
    const { branch_id } = action.payload;
    const url = API_URLS.QUICK_BOOK.QBO_BACKUP_LATEST + `?branch_id=${branch_id}`
    let result = yield call(CallApi.GET, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbFetchLedgerAudit(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.QUICK_BOOK.QB_LEDGER_AUDIT + `?` + formQueryString(payload)
    let result = yield call(CallApi.GET, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbFetchBackupStatus(action: any): any {
  try {
    const { job_id } = action.payload;
    const url = API_URLS.QUICK_BOOK.QBO_BACKUP_STATUS + `/${job_id}`
    let result = yield call(CallApi.GET, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbRetryBackup(action: any): any {
  try {
    const { job_id, entity_name } = action.payload;
    const url = API_URLS.QUICK_BOOK.QBO_BACKUP_RETRY + `/${job_id}`
      + (entity_name ? `?entity_name=${entity_name}` : '')
    let result = yield call(CallApi.POST, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbRetryLedgerPeriod(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.QUICK_BOOK.QB_LEDGER_RETRY + `?` + formQueryString(payload)
    let result = yield call(CallApi.POST, url, {}, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbRetryLedgerPeriods(action: any): any {
  try {
    const { branch_id, periods } = action.payload;
    const url = API_URLS.QUICK_BOOK.QB_LEDGER_RETRY_ALL + `?branch_id=${branch_id}`
    let result = yield call(CallApi.POST, url, { periods }, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* qbSaveLedgerMappings(action: any): any {
  try {
    const { branch_id, lines, register_overrides } = action.payload;
    const url = API_URLS.QUICK_BOOK.QB_LEDGER_MAPPINGS + `?branch_id=${branch_id}`
    let result = yield call(CallApi.POST, url, { lines, register_overrides }, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}
